var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: { size: "lg", "before-close": _vm.close, footer: false },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _c("h3", [
                    _c("i", {
                      staticClass: "fa fa-trophy m-r-5",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v("\n        " + _vm._s(_vm.header) + "\n      ")
                  ])
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _vm._v(" "),
          _c("p", [_vm._v("\n      " + _vm._s(_vm.intro) + "\n    ")]),
          _vm._v(" "),
          _c("div", { staticClass: "panel panel-default bottom" }, [
            _c("div", { staticClass: "panel-heading" }, [
              _c(
                "h3",
                { staticClass: "panel-title" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.introHeader))]),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "env-chooser pull-right",
                    attrs: {
                      label: "title",
                      options: _vm.modes,
                      value: _vm.selectedEnvironment,
                      clearable: false,
                      searchable: false
                    },
                    on: { input: _vm.setEnvironment },
                    scopedSlots: _vm._u([
                      {
                        key: "option",
                        fn: function(option) {
                          return [
                            _c("h5", {
                              staticClass: "env-title",
                              domProps: { textContent: _vm._s(option.title) }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "env-content",
                              domProps: { textContent: _vm._s(option.content) }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "panel-body" }, [
              _c(
                "div",
                { staticClass: "panel-group", attrs: { role: "tablist" } },
                _vm._l(_vm.options, function(option) {
                  return _c(
                    "div",
                    {
                      key: option.index,
                      attrs: { "data-testid": "rtb-documentation-option" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "panel panel-default",
                          class: {
                            "panel-dynamic-inbound-calls": option.index > 0
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "accordion-toggle",
                              attrs: {
                                role: "button",
                                "data-toggle": "collapse",
                                "aria-expanded": "false",
                                "data-cy": "rtb-documentation-option-tab"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleAccordion(option.index)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "panel-heading panel-heading-dynamic-inbound-calls",
                                  attrs: {
                                    role: "tab",
                                    "aria-selected": "false"
                                  }
                                },
                                [
                                  _c("h4", { staticClass: "panel-title" }, [
                                    _c("a", [_vm._v(_vm._s(option.title))]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "pull-right glyphicon",
                                      class: {
                                        "glyphicon-chevron-down":
                                          _vm.showAccordion[option.index],
                                        "glyphicon-chevron-right": !_vm
                                          .showAccordion[option.index]
                                      }
                                    })
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "collapse",
                            {
                              model: {
                                value: _vm.showAccordion[option.index],
                                callback: function($$v) {
                                  _vm.$set(_vm.showAccordion, option.index, $$v)
                                },
                                expression: "showAccordion[option.index]"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "panel-body" },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(option.content) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(option.callouts, function(callout) {
                                    return _c(
                                      "div",
                                      {
                                        key: callout,
                                        staticClass:
                                          "bs-callout bs-callout-info"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "glyphicon glyphicon-info-sign",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(
                                          _vm._s(callout) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm._l(option.subOptions, function(
                                    subOption
                                  ) {
                                    return _c("div", { key: subOption.title }, [
                                      _c("h5", { staticClass: "m-b-5" }, [
                                        subOption.title
                                          ? _c("a", [
                                              _vm._v(_vm._s(subOption.title))
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      subOption.segments.length
                                        ? _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip.right",
                                                  value: _vm.textBoxToolTip,
                                                  expression: "textBoxToolTip",
                                                  modifiers: { right: true }
                                                },
                                                {
                                                  name: "clipboard",
                                                  rawName: "v-clipboard",
                                                  value: {
                                                    copyText: _vm.joinSegments(
                                                      subOption.segments
                                                    )
                                                  },
                                                  expression:
                                                    "{ copyText: joinSegments(subOption.segments) }"
                                                }
                                              ],
                                              staticClass:
                                                "code-container clickable",
                                              on: {
                                                click:
                                                  _vm.handleCodeContainerClick
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "copy-code btn btn-function",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "typcn typcn-tabs-outline"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              subOption.segments.length
                                                ? _c(
                                                    "pre",
                                                    {
                                                      staticClass:
                                                        "p-t-0 p-b-0",
                                                      class: {
                                                        "text-success":
                                                          _vm.codeCopied
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "                        "
                                                      ),
                                                      _c(
                                                        "code",
                                                        {
                                                          attrs: {
                                                            "data-testid":
                                                              "rtb-documentation-example"
                                                          }
                                                        },
                                                        [
                                                          _c("br"),
                                                          _vm._l(
                                                            subOption.segments,
                                                            function(
                                                              segment,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  key: index,
                                                                  class: {
                                                                    "rtb-required-tag":
                                                                      segment.isRequired
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      segment.text
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(
                                                        "\n                      "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button" },
                on: { click: _vm.close }
              },
              [_vm._v("\n        " + _vm._s(_vm.closeButtonLabel) + "\n      ")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }